export default "__VITE_ASSET__Blmdlii2__"